(function () {
  if (window.__simplerBlogGeneralNewsBound) return;
  window.__simplerBlogGeneralNewsBound = true;

  function parseNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function esc(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function srcsetFor(url, widths) {
    return widths
      .map(function (w) {
        return esc(withWidth(url, w)) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function stripHtml(text) {
    return String(text == null ? '' : text)
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function truncateWords(text, limit) {
    var words = stripHtml(text).split(' ').filter(Boolean);
    if (!words.length) return '';
    if (words.length <= limit) return words.join(' ');
    return words.slice(0, limit).join(' ') + '...';
  }

  function buildSearchQuery(blogTitle, tag) {
    var parts = [];
    if (blogTitle) parts.push("blog_title:'" + blogTitle.replace(/(['\\])/g, '\\$1') + "'");
    if (tag) parts.push("tag:'" + tag.replace(/(['\\])/g, '\\$1') + "'");
    return parts.join(' AND ');
  }

  var ARTICLES_QUERY =
    'query SbgnArticles($q: String!, $n: Int!) {' +
    '  articles(first: $n, sortKey: PUBLISHED_AT, reverse: true, query: $q) {' +
    '    edges { node {' +
    '      title handle onlineStoreUrl' +
    '      excerpt content(truncateAt: 600)' +
    '      image { url altText }' +
    '    } }' +
    '  }' +
    '}';

  function sfRequest(config, query, variables) {
    if (window.StorefrontClient && typeof window.StorefrontClient.request === 'function') {
      return window.StorefrontClient.request(query, variables);
    }
    if (!config.shop || !config.token) return Promise.resolve(null);
    var endpoint = 'https://' + config.shop + '/api/' + config.version + '/graphql.json';
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token,
      },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) {
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function getTagConfig(container) {
    var excerptWords = parseInt(container.getAttribute('data-sbgn-excerpt-words'), 10);
    var limit = parseInt(container.getAttribute('data-sbgn-limit'), 10);
    return {
      shop: container.getAttribute('data-sbgn-shop'),
      version: container.getAttribute('data-sbgn-version') || '2024-10',
      token: container.getAttribute('data-sbgn-token') || window.SF_API_TOKEN,
      blogHandle: container.getAttribute('data-sbgn-blog-handle') || '',
      blogTitle: container.getAttribute('data-sbgn-blog-title') || '',
      tag: container.getAttribute('data-sbgn-tag') || '',
      limit: Number.isInteger(limit) && limit > 0 ? limit : 12,
      excerptWords: Number.isInteger(excerptWords) && excerptWords > 0 ? excerptWords : 18,
      buttonLabel: container.getAttribute('data-sbgn-button-label') || 'Read More',
      hideWithoutImage: container.getAttribute('data-sbgn-hide-without-image') === 'true',
    };
  }

  function hasArticleImage(node) {
    return !!(node && node.image && node.image.url);
  }

  function filterArticles(articles, config) {
    var filtered = articles;
    if (config.hideWithoutImage) {
      filtered = filtered.filter(hasArticleImage);
    }
    return filtered.slice(0, config.limit);
  }

  function articleUrl(node, config) {
    return node.onlineStoreUrl || '/blogs/' + config.blogHandle + '/' + node.handle;
  }

  function cardHTML(node, config) {
    var url = articleUrl(node, config);
    var thumb =
      node.image && node.image.url
        ? '<img class="sbgn-card__image" src="' +
          esc(withWidth(node.image.url, 400)) +
          '" srcset="' +
          srcsetFor(node.image.url, [120, 160, 200, 280, 400]) +
          '" sizes="120px" loading="lazy" alt="' +
          esc(node.image.altText || node.title || '') +
          '">'
        : '<span class="sbgn-card__placeholder" aria-hidden="true"></span>';
    var excerpt = truncateWords(node.excerpt || node.content || '', config.excerptWords);

    return (
      '<article class="sbgn-card">' +
      '<a href="' +
      esc(url) +
      '" class="sbgn-card__thumb">' +
      thumb +
      '</a>' +
      '<div class="sbgn-card__body">' +
      (node.title
        ? '<h3 class="sbgn-card__title"><a href="' + esc(url) + '">' + esc(node.title) + '</a></h3>'
        : '') +
      '<p class="sbgn-card__excerpt">' +
      esc(excerpt) +
      '</p>' +
      '<a href="' +
      esc(url) +
      '" class="sbgn-card__button">' +
      esc(config.buttonLabel) +
      '</a>' +
      '</div></article>'
    );
  }

  function fetchArticles(config) {
    var fetchLimit = config.limit;
    if (config.hideWithoutImage) {
      fetchLimit = Math.min(Math.max(config.limit * 3, config.limit), 50);
    }

    return sfRequest(config, ARTICLES_QUERY, {
      q: buildSearchQuery(config.blogTitle, config.tag),
      n: fetchLimit,
    }).then(function (json) {
      var conn = json && json.data && json.data.articles;
      if (!conn) return null;
      var articles = (conn.edges || [])
        .map(function (edge) {
          return edge && edge.node;
        })
        .filter(Boolean);
      return filterArticles(articles, config);
    });
  }

  function mountSlider(slider) {
    if (typeof Swiper === 'undefined') return null;

    var el = slider.querySelector('.sbgn-swiper');
    if (!el) return null;

    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return null;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    var scrollbarEl = slider.querySelector('.sbgn-scrollbar');
    var gapMobile = parseNumber(slider.dataset.gapMobile, 12);

    return new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: gapMobile,
      speed: 450,
      watchOverflow: true,
      grabCursor: true,
      simulateTouch: true,
      observer: true,
      observeParents: true,
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            dragSize: 'auto',
          }
        : undefined,
    });
  }

  function mountSliders(sectionRoot) {
    sectionRoot.querySelectorAll('[data-sbgn-slider]').forEach(function (slider) {
      window.requestAnimationFrame(function () {
        var swiper = mountSlider(slider);
        if (swiper) {
          swiper.slideTo(0, 0);
          swiper.update();
        }
      });
    });
  }

  function loadTaggedArticles(container) {
    var config = getTagConfig(container);
    var hasClient = !!(window.StorefrontClient && window.StorefrontClient.request);
    if (!hasClient && (!config.shop || !config.token || !config.tag)) return Promise.resolve();

    var sliderWrapper = container.querySelector('[data-sbgn-slider-wrapper]');
    var grid = container.querySelector('[data-sbgn-grid]');
    var emptyEl = container.querySelector('[data-sbgn-empty]');

    container.setAttribute('aria-busy', 'true');

    return fetchArticles(config)
      .then(function (articles) {
        container.removeAttribute('aria-busy');
        if (articles === null) return;

        if (!articles.length) {
          if (sliderWrapper) sliderWrapper.innerHTML = '';
          if (grid) grid.innerHTML = '';
          if (emptyEl) emptyEl.removeAttribute('hidden');
          return;
        }

        var cards = articles.map(function (node) {
          return cardHTML(node, config);
        });

        if (sliderWrapper) {
          sliderWrapper.innerHTML = cards
            .map(function (html) {
              return '<div class="swiper-slide">' + html + '</div>';
            })
            .join('');
        }

        if (grid) grid.innerHTML = cards.join('');
        if (emptyEl) emptyEl.setAttribute('hidden', '');

        mountSliders(container.closest('.simpler-blog-general-news') || container.parentElement || document);
      })
      .catch(function () {
        container.removeAttribute('aria-busy');
        if (emptyEl) emptyEl.removeAttribute('hidden');
      });
  }

  function mountSection(sectionRoot) {
    var containers = sectionRoot.querySelectorAll('.sbgn-container[data-sbgn-filter-by-tag]');
    if (containers.length) {
      containers.forEach(function (container) {
        loadTaggedArticles(container);
      });
      return;
    }

    mountSliders(sectionRoot);
  }

  function boot(root) {
    (root || document).querySelectorAll('.simpler-blog-general-news').forEach(mountSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!root) return;
    boot(root);
  });
})();
